(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mto-personalized-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mto-pwa-recommendations]').forEach((container) => {
    if (container.dataset.mtoSwipeBound === 'true') return;
    container.dataset.mtoSwipeBound = 'true';

    const dialog = container.querySelector('[data-mto-swipe-dialog]');
    const closeButton = container.querySelector('[data-mto-swipe-close]');
    const status = container.querySelector('[data-mto-swipe-status]');
    const count = container.querySelector('[data-mto-swipe-count]');
    const storageKey = 'mto_recent_product_ids_v1';
    const dismissedKey = 'mto_dismissed_recommendation_ids_v1';
    const openedKey = 'mto_pwa_recommendations_opened_v1';
    const shopRoot = window.Shopify?.routes?.root || '/';
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

    if (!dialog || (!isStandalone && !isDesignMode)) return;
    if (container.dataset.showOnce === 'true' && sessionStorage.getItem(openedKey) === 'true' && !isDesignMode) return;

    let deck = container.querySelector('[data-mto-swipe-deck]');
    let isBusy = false;
    let dragging = false;
    let startX = 0;
    let startY = 0;
    let deltaX = 0;
    let deltaY = 0;

    const readStoredArray = (key) => {
      try {
        const value = JSON.parse(localStorage.getItem(key) || '[]');
        return Array.isArray(value) ? value.map(String) : [];
      } catch (error) {
        return [];
      }
    };

    const cards = () => Array.from(deck.querySelectorAll('[data-mto-swipe-card]'));

    const updateCartCount = (cart) => {
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
        const accessibleCount = bubble.querySelector('.visually-hidden');
        if (visibleCount) visibleCount.textContent = cart.item_count;
        if (accessibleCount) accessibleCount.textContent = `${cart.item_count} ${container.dataset.cartCountLabel}`;
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    };

    const showCurrentCard = () => {
      const currentCards = cards();
      currentCards.forEach((card, index) => {
        card.hidden = index !== 0;
        card.classList.remove('is-exiting-left', 'is-exiting-right', 'is-exiting-up');
        card.style.removeProperty('transform');
        card.style.removeProperty('opacity');
      });

      count.textContent = currentCards.length ? `1 / ${currentCards.length}` : '';

      if (!currentCards.length) {
        status.textContent = container.dataset.emptyMessage;
        window.setTimeout(() => dialog.close(), 700);
      }
    };

    const animateCard = (card, className, complete) => {
      card.classList.add(className);
      window.setTimeout(complete, 230);
    };

    const skipCard = () => {
      if (isBusy) return;
      const card = cards()[0];
      if (!card) return;

      animateCard(card, 'is-exiting-left', () => {
        deck.append(card);
        showCurrentCard();
      });
    };

    const dismissCard = () => {
      if (isBusy) return;
      const card = cards()[0];
      if (!card) return;

      const dismissedIds = readStoredArray(dismissedKey);
      const productId = String(card.dataset.productId);
      localStorage.setItem(dismissedKey, JSON.stringify([...new Set([productId, ...dismissedIds])].slice(0, 100)));

      animateCard(card, 'is-exiting-up', () => {
        card.remove();
        showCurrentCard();
      });
    };

    const addCardToCart = async () => {
      if (isBusy) return;
      const card = cards()[0];
      if (!card) return;

      isBusy = true;
      status.textContent = container.dataset.addingMessage;

      try {
        const response = await fetch(window.routes?.cart_add_url || `${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(card.dataset.variantId),
              quantity: 1
            }]
          })
        });

        if (!response.ok) throw new Error('Cart request failed');

        status.textContent = container.dataset.addedMessage;

        try {
          const cartResponse = await fetch(`${shopRoot}cart.js`);
          if (cartResponse.ok) updateCartCount(await cartResponse.json());
        } catch (error) {
          status.textContent = container.dataset.addedMessage;
        }

        animateCard(card, 'is-exiting-right', () => {
          card.remove();
          isBusy = false;
          showCurrentCard();
        });
      } catch (error) {
        isBusy = false;
        status.textContent = container.dataset.errorMessage;
        card.style.removeProperty('transform');
        card.style.removeProperty('opacity');
      }
    };

    const bindCard = (card) => {
      card.querySelector('[data-mto-action="skip"]')?.addEventListener('click', skipCard);
      card.querySelector('[data-mto-action="add"]')?.addEventListener('click', addCardToCart);
      card.querySelector('[data-mto-action="remove"]')?.addEventListener('click', dismissCard);

      card.addEventListener('pointerdown', (event) => {
        if (isBusy || event.target.closest('button, a')) return;
        dragging = true;
        startX = event.clientX;
        startY = event.clientY;
        deltaX = 0;
        deltaY = 0;
        card.setPointerCapture(event.pointerId);
      });

      card.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        deltaX = event.clientX - startX;
        deltaY = event.clientY - startY;
        const rotation = Math.max(-10, Math.min(10, deltaX / 18));
        card.style.transform = `translate(${deltaX}px, ${deltaY}px) rotate(${rotation}deg)`;
        card.style.opacity = String(Math.max(0.45, 1 - Math.max(Math.abs(deltaX), Math.abs(deltaY)) / 420));
      });

      card.addEventListener('pointerup', () => {
        if (!dragging) return;
        dragging = false;
        const horizontal = Math.abs(deltaX) > Math.abs(deltaY);

        if (horizontal && deltaX <= -70) {
          skipCard();
        } else if (horizontal && deltaX >= 70) {
          addCardToCart();
        } else if (!horizontal && deltaY <= -70) {
          dismissCard();
        } else {
          card.style.removeProperty('transform');
          card.style.removeProperty('opacity');
        }
      });

      card.addEventListener('pointercancel', () => {
        dragging = false;
        card.style.removeProperty('transform');
        card.style.removeProperty('opacity');
      });
    };

    const prepareDeck = () => {
      const dismissedIds = new Set(readStoredArray(dismissedKey));
      cards().forEach((card) => {
        if (dismissedIds.has(String(card.dataset.productId))) {
          card.remove();
        } else {
          bindCard(card);
        }
      });
      showCurrentCard();
    };

    const openDialog = () => {
      if (!cards().length) return;
      if (!isDesignMode) sessionStorage.setItem(openedKey, 'true');
      if (!dialog.open) dialog.showModal();
    };

    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    const recentProductIds = readStoredArray(storageKey);
    const seedProductId = recentProductIds[0] || container.dataset.fallbackProductId;

    const finish = () => {
      prepareDeck();
      openDialog();
    };

    if (!seedProductId) {
      finish();
      return;
    }

    const query = new URLSearchParams({
      section_id: container.dataset.sectionId,
      product_id: seedProductId,
      limit: container.dataset.limit,
      intent: 'related'
    });

    fetch(`${container.dataset.endpoint}?${query.toString()}`)
      .then((response) => {
        if (!response.ok) throw new Error('Recommendation request failed');
        return response.text();
      })
      .then((responseText) => {
        const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
        const replacementDeck = responseDocument.querySelector('[data-mto-swipe-deck]');

        if (replacementDeck && replacementDeck.children.length) {
          deck.replaceWith(replacementDeck);
          deck = replacementDeck;
        }
      })
      .catch(() => {})
      .finally(finish);
  });

  } catch(e) { console.error(e); }
})();
})();
